// Mirror of frontend/libs/pantry-features/src/features/Category/utils/media.ts.
// Duplicated locally so the Loyalty Wallet tab can mount a
// GalleryPickerWithProvider without reaching across feature boundaries.
// MEDIA_FOLDER_STATIC mirrors frontend/src/constants/media.ts:6-9.

const MEDIA_FOLDER_STATIC = {
  ALL_FILE: 'all_file',
  UNSORTED: 'un_sorted',
} as const

interface MediaFileLike {
  content_type?: string
}

export const isFileImage = (file: MediaFileLike): boolean =>
  file.content_type ? file.content_type.split('/')[0] === 'image' : true

export const getFolderId = (id: string): string | undefined => {
  if (id === MEDIA_FOLDER_STATIC.ALL_FILE) {
    return undefined
  }
  if (id === MEDIA_FOLDER_STATIC.UNSORTED) {
    return ''
  }
  return id
}
